import { getPath } from "../../utils";

const initialState = {
  menus: new Set(),
  menuActions: {},
  allMenuActions: {},
  failedToFetchMenu: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_MENUS":
      return setMenus(state, action);
    case "SET_MENU_ACTIONS":
      return setMenuActions(state, action);
    case "SET_FAILED_TO_FETCH_MENU":
      return setFailedToFetchMenu(state, action);
    default:
      return state;
  }
}

const setFailedToFetchMenu = (state, action) => {
  return {
    ...state,
    failedToFetchMenu: true,
  };
};

const setMenus = (state, action) => {
  return {
    ...state,
    menus: new Set(getPath(action, "payload.menus", [])),
    failedToFetchMenu: false,
  };
};

const setMenuActions = (state, action) => {
  return {
    ...state,
    failedToFetchMenu: false,
    menuActions: {
      ...state.menuActions,
      [action.payload.menuName]: {
        ...state.menuActions[action.payload.menuName],
        ...action.payload.status_map,
      },
    },
    allMenuActions: {
      ...state.allMenuActions,
      ...action.payload.status_map,
    },
  };
};
